"use client"

import Button from "@src/components/Button"
import type { ComponentProps } from "react"
import { type LandingCtaLocation, trackLandingCta } from "./landingAnalytics"

type Props = Omit<ComponentProps<typeof Button>, "onClick" | "href"> & {
  /** Where on the landing page this CTA lives — the funnel dimension. */
  location: Extract<LandingCtaLocation, "hero" | "closing">
}

/** Landing page acquisition CTA: links to /login and reports the click. */
export default function LandingCta({ location, ...props }: Props) {
  return (
    <Button
      {...props}
      href="/login"
      onClick={() => trackLandingCta(location)}
    />
  )
}
